import { Client, Functions } from "appwrite";

const client = new Client()
  .setEndpoint("https://appwrite.malaweb.fr/v1")
  .setProject("6892288f000ba42b9893");
const functions = new Functions(client);

export { functions };
